'use client'

import Link from 'next/link'
import { useState, useEffect } from 'react'

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [prestationsOpen, setPrestationsOpen] = useState(false)


  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden'
      document.body.style.position = 'fixed'
      document.body.style.width = '100%'
    } else {
      document.body.style.overflow = ''
      document.body.style.position = ''
      document.body.style.width = ''
    }
  }, [mobileMenuOpen])

  // Style inline pour forcer les couleurs saumon
  const linkStyle = {
    color: '#c96f54',
    fontWeight: '600' as const,
    textDecoration: 'none',
    transition: 'color 0.3s'
  }

  return (
    <>
      <header>
        <nav style={{
          display: 'grid',
          gridTemplateColumns: '1fr auto 1fr',
          alignItems: 'center',
          width: '100%'
        }}>
          {/* Logo */}
          <div className="logo">
            
           <Link href="/" className="logo-link">
  <img 
    src="/logo.svg" 
    alt="Léna Lahor Coaching - Accompagner l'épanouissement" 
    className="logo-image"
    width={180}
    height={60}
  />
</Link>
          
          </div>
          
          {/* Menu hamburger - UNIQUEMENT visible sur mobile */}
          <button 
            className="hamburger-btn" 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Menu"
            style={{
              display: 'none',
              position: 'absolute',
              right: '2rem',
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: '2rem',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: '#c96f54',
              zIndex: 1002,
              padding: '0.5rem'
            }}
          >
            ☰
          </button>
          
          {/* Navigation - Cachée sur mobile par défaut */}
          <ul 
            className={`main-nav ${mobileMenuOpen ? 'is-open' : ''}`}
            style={{
              display: 'flex',
              justifyContent: 'center',
              margin: 0,
              padding: 0,
              listStyle: 'none',
              gap: '2rem',
              alignItems: 'center'
            }}
          >
            <li style={{ margin: 0 }}>
              <Link 
                href="/" 
                onClick={() => setMobileMenuOpen(false)}
                className="nav-link"
                style={{ color: '#c96f54', fontWeight: '600', textDecoration: 'none' }}
              >
                Accueil
              </Link>
            </li>
            
            {/* Prestations avec dropdown */}
            <li style={{ position: 'relative', margin: 0 }}>
              <div
                onMouseEnter={() => setPrestationsOpen(true)}
                onMouseLeave={() => setPrestationsOpen(false)}
                style={{ position: 'relative' }}
              >
                <button
                  onClick={() => setPrestationsOpen(!prestationsOpen)}
                  className="prestations-btn"
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: 'inherit',
                    fontWeight: '600',
                    color: '#c96f54',
                    padding: 0
                  }}
                >
                  Prestations
                </button>

                {prestationsOpen && (
                  <div className="dropdown-menu" style={{
                    position: 'absolute',
                    top: '100%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    paddingTop: '1rem',
                    zIndex: 1000
                  }}>
                    <div className="dropdown-arrow" style={{
                      position: 'absolute',
                      top: '0.5rem',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      width: 0,
                      height: 0,
                      borderLeft: '10px solid transparent',
                      borderRight: '10px solid transparent',
                      borderBottom: '10px solid white',
                      zIndex: 1001
                    }}></div>

                    <div style={{
                      backgroundColor: 'white',
                      borderRadius: '15px',
                      boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
                      padding: '1.5rem',
                      minWidth: '950px'
                    }}>
                      <div className="prestations-grid-wrapper" style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(4, 1fr)',
                        gap: '1.5rem'
                      }}>
                        
                        {/* Carte 1 - Hypnose */}
                        <Link 
                          href="/hypnose" 
                          style={{ textDecoration: 'none' }}
                          onClick={() => { 
                            setPrestationsOpen(false); 
                            setMobileMenuOpen(false); 
                          }}
                        >
                          <div className="prestation-card" style={{
                            position: 'relative',
                            height: '140px',
                            borderRadius: '12px',
                            overflow: 'hidden',
                            cursor: 'pointer',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                            boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
                          }}>
                            <div style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backgroundImage: 'url(/images/motifs/addictions.jpg)',
                              backgroundSize: 'cover',
                              backgroundPosition: 'center'
                            }}></div>
                            <div style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backgroundColor: 'rgba(163, 193, 173, 0.8)',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: '1rem'
                            }}>
                              <h3 style={{
                                color: 'white',
                                fontFamily: "'Dancing Script', 'Great Vibes', 'Pacifico', cursive",
                                fontSize: '1.3rem',
                                fontWeight: '400',
                                textAlign: 'center',
                                marginBottom: '0.3rem',
                                margin: 0
                              }}>
                                Hypnose Maïeutique
                              </h3>
                              <p style={{
                                color: 'white',
                                fontSize: '0.75rem',
                                fontWeight: '300',
                                textAlign: 'center',
                                opacity: 0.9,
                                margin: 0
                              }}>
                                Thérapie en profondeur
                              </p>
                            </div>
                          </div>
                        </Link>

                        {/* Carte 2 - Thérapie */}
                        <Link 
                          href="/therapie" 
                          style={{ textDecoration: 'none' }}
                          onClick={() => { 
                            setPrestationsOpen(false); 
                            setMobileMenuOpen(false); 
                          }}
                        >
                          <div className="prestation-card" style={{
                            position: 'relative',
                            height: '140px',
                            borderRadius: '12px',
                            overflow: 'hidden',
                            cursor: 'pointer',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                            boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
                          }}>
                            <div style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backgroundImage: 'url(/images/motifs/maux-du-corps.jpg)',
                              backgroundSize: 'cover',
                              backgroundPosition: 'center'
                            }}></div>
                            <div style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backgroundColor: 'rgba(201, 111, 84, 0.8)',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: '1rem'
                            }}>
                              <h3 style={{
                                color: 'white',
                                fontFamily: "'Dancing Script', 'Great Vibes', 'Pacifico', cursive",
                                fontSize: '1.3rem',
                                fontWeight: '400',
                                textAlign: 'center',
                                marginBottom: '0.3rem',
                                margin: 0
                              }}>
                                Thérapie
                              </h3>
                              <p style={{
                                color: 'white',
                                fontSize: '0.75rem',
                                fontWeight: '300',
                                textAlign: 'center',
                                opacity: 0.9,
                                margin: 0
                              }}>
                                Accompagnement personnalisé
                              </p>
                            </div>
                          </div>
                        </Link>

                        {/* Carte 3 - Conférences */}
                        <Link 
                          href="/conferences" 
                          style={{ textDecoration: 'none' }}
                          onClick={() => { 
                            setPrestationsOpen(false); 
                            setMobileMenuOpen(false); 
                          }}
                        >
                          <div className="prestation-card" style={{
                            position: 'relative',
                            height: '140px',
                            borderRadius: '12px',
                            overflow: 'hidden',
                            cursor: 'pointer',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                            boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
                          }}>
                            <div style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backgroundImage: 'url(/images/conferences1.jpg)',
                              backgroundSize: 'cover',
                              backgroundPosition: 'center'
                            }}></div>
                            <div style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backgroundColor: 'rgba(74, 111, 90, 0.8)',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: '1rem'
                            }}>
                              <h3 style={{
                                color: 'white',
                                fontFamily: "'Dancing Script', 'Great Vibes', 'Pacifico', cursive",
                                fontSize: '1.3rem',
                                fontWeight: '400',
                                textAlign: 'center',
                                marginBottom: '0.3rem',
                                margin: 0
                              }}>
                                Conférences
                              </h3>
                              <p style={{
                                color: 'white',
                                fontSize: '0.75rem',
                                fontWeight: '300',
                                textAlign: 'center',
                                opacity: 0.9,
                                margin: 0
                              }}>
                                Interventions professionnelles
                              </p>
                            </div>
                          </div>
                        </Link>

                        {/* Carte 4 - Ateliers */}
                        <Link 
                          href="/cercles" 
                          style={{ textDecoration: 'none' }}
                          onClick={() => { 
                            setPrestationsOpen(false); 
                            setMobileMenuOpen(false); 
                          }}
                        >
                          <div className="prestation-card" style={{
                            position: 'relative',
                            height: '140px',
                            borderRadius: '12px',
                            overflow: 'hidden',
                            cursor: 'pointer',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                            boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
                          }}>
                            <div style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backgroundImage: 'url(/images/atelier-gestion-stress.jpg)',
                              backgroundSize: 'cover',
                              backgroundPosition: 'center'
                            }}></div>
                            <div style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backgroundColor: 'rgba(255, 182, 193, 0.8)',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: '1rem'
                            }}>
                              <h3 style={{
                                color: 'white',
                                fontFamily: "'Dancing Script', 'Great Vibes', 'Pacifico', cursive",
                                fontSize: '1.3rem',
                                fontWeight: '400',
                                textAlign: 'center',
                                marginBottom: '0.3rem',
                                margin: 0
                              }}>
                                Ateliers & Cercles
                              </h3>
                              <p style={{
                                color: 'white',
                                fontSize: '0.75rem',
                                fontWeight: '300',
                                textAlign: 'center',
                                opacity: 0.9,
                                margin: 0
                              }}>
                                Programmes collectifs
                              </p>
                            </div>
                          </div>
                        </Link>

                      </div>
                    </div>
                  </div>
                )}
              </div>
            </li>
            
            <li style={{ margin: 0 }}>
              <Link
                href="/evenements"
                onClick={() => setMobileMenuOpen(false)}
                className="nav-link"
                style={{ color: '#c96f54', fontWeight: '600', textDecoration: 'none' }}
              >
                Événements
              </Link>
            </li>

            <li style={{ margin: 0 }}>
              <Link
                href="/blog"
                onClick={() => setMobileMenuOpen(false)}
                className="nav-link"
                style={{ color: '#c96f54', fontWeight: '600', textDecoration: 'none' }}
              >
                Blog
              </Link>
            </li>
            
            <li style={{ margin: 0 }}>
              <Link 
                href="/contact" 
                onClick={() => setMobileMenuOpen(false)}
                className="nav-link"
                style={{ color: '#c96f54', fontWeight: '600', textDecoration: 'none' }}
              >
                Contact
              </Link>
            </li>
          </ul>
          
          <div></div>
        </nav>
      </header>

      <style jsx>{`
        /* Empêcher le scroll horizontal sur TOUTE la page */
        :global(html) {
          overflow-x: hidden !important;
          max-width: 100vw !important;
        }

        :global(body) {
          overflow-x: hidden !important;
          max-width: 100vw !important;
        }

        :global(main) {
          overflow-x: hidden !important;
          max-width: 100vw !important;
        }

        /* DESKTOP - Liens en SAUMON */
        .nav-link {
          color: #c96f54 !important;
          font-weight: 600 !important;
          text-decoration: none !important;
        }

        .nav-link:hover {
          color: #b85f44 !important;
        }

        /* Hamburger - caché sur desktop */
        @media (min-width: 769px) {
          .hamburger-btn {
            display: none !important;
          }
        }

        /* Mobile responsive */
        @media (max-width: 768px) {
          .hamburger-btn {
            display: block !important;
          }

          .main-nav {
            position: fixed !important;
            top: 0 !important;
            right: -100% !important;
            height: 100vh !important;
            width: 80% !important;
            max-width: 350px !important;
            background-color: #1a2332 !important; /* Bleu marine foncé comme le footer */
            box-shadow: -5px 0 15px rgba(0,0,0,0.3) !important;
            flex-direction: column !important;
            justify-content: flex-start !important;
            align-items: flex-start !important;
            padding: 4rem 2rem 2rem 2rem !important;
            gap: 2rem !important;
            transition: right 0.3s ease !important;
            z-index: 1001 !important;
            overflow-y: auto !important;
          }

          /* MOBILE - TOUS les liens en CORAIL (forcer avec !important) */
          .main-nav .nav-link,
          .main-nav .prestations-btn {
            color: #e89b8f !important; /* Corail */
            font-size: 1.1rem !important;
            font-weight: 600 !important;
            text-decoration: none !important;
          }

          .main-nav .nav-link:hover,
          .main-nav .prestations-btn:hover {
            color: #ffffff !important; /* Blanc au hover */
            text-decoration: none !important;
          }

          .main-nav.is-open {
            right: 0 !important;
          }

          /* Overlay sombre + empêcher scroll */
          .main-nav.is-open::before {
            content: '';
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background-color: rgba(0,0,0,0.7);
            z-index: -1;
          }

          .main-nav li {
            width: 100%;
            text-align: left;
            border-bottom: 1px solid rgba(255,255,255,0.1);
            padding-bottom: 1rem;
          }

          .main-nav li:last-child {
            border-bottom: none;
          }

          /* Dropdown mobile */
          .dropdown-menu {
            position: static !important;
            transform: none !important;
            padding-top: 1rem !important;
            width: 100% !important;
            left: 0 !important;
          }

          .dropdown-arrow {
            display: none !important;
          }

          .dropdown-menu > div:last-child {
            min-width: auto !important;
            width: 100% !important;
            margin: 0 !important;
            padding: 1rem !important;
            background-color: rgba(255,255,255,0.05) !important;
            border-radius: 10px !important;
          }

          .prestations-grid-wrapper {
            grid-template-columns: 1fr !important;
            gap: 1rem !important;
          }

          .prestation-card:hover {
            transform: none !important;
          }
        }
      `}</style>
    </>
  )
}
